import { gql, useQuery } from '@apollo/client'

import {
  AccountSettings,
  AccountSettingsQuery,
  ArtistMembershipCompletionQuery,
  ArtistMembershipCompletionQueryVariables,
  PaymentMethod,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } =
    useRouter<{ artistId: string; pendingPurchaseId?: string }>()

  const { data, loading } = useQuery<
    ArtistMembershipCompletionQuery,
    ArtistMembershipCompletionQueryVariables
  >(QUERY, {
    variables: {
      pendingPurchaseId: router.query.pendingPurchaseId ?? '',
    },
    skip: !router.query.pendingPurchaseId,
  })

  const { data: userData } = useQuery<AccountSettingsQuery>(AccountSettings)

  return {
    state: {
      loading,
      user: userData?.user,
      artistId:
        (config.applicationType === 'standalone'
          ? config.artistId
          : router.query.artistId) ?? '#',
      paymentMethod: router.query.pendingPurchaseId
        ? PaymentMethod.Konbini
        : PaymentMethod.CreditCard,
      formattedExpiredAt: data?.pendingPurchaseItem?.formattedExpiredAt ?? null,
      voucherUrl: data?.pendingPurchaseItem?.voucherUrl ?? null,
    },
    actions: {},
  }
})

const QUERY = gql`
  query ArtistMembershipCompletion($pendingPurchaseId: ID!) {
    pendingPurchaseItem(pendingPurchaseId: $pendingPurchaseId) {
      id
      expiredAt
      formattedExpiredAt @client
      voucherUrl
    }
  }
`
